import { formatMoney } from '@/i18n';
import { minorUnitsToDisplayAmount } from '@/utils/zeroDecimalCurrencies';

/**
 * Format an integer amount in the smallest currency unit into a localized
 * currency string.
 *
 * Negative amounts are rendered with a leading minus sign on the absolute
 * value (e.g. -9900 -> "-$99.00") to match the wallet/ledger conventions used
 * across the billing UI.
 *
 * @param amountCents Integer amount in the smallest currency unit.
 * @param currency ISO 4217 currency code (case-insensitive). Defaults to USD.
 */
export function formatCents(amountCents: number, currency = 'USD'): string {
  // Локаль ПИННИТСЯ английской, а не берётся из языка кабинета: при локали
  // окружения USD рендерится как «US$2.44» вместо «$2.44» (расхождение с
  // макетом), а русская раскладка дала бы «2,44 $» — знак после числа. Пин
  // даёт детерминированный «$»-формат везде: контракт из formatCents.test.ts.
  // WEB-1874 менял ЗДЕСЬ только дверь (строка локали живёт в i18n/format.ts),
  // но не смысл: раскладка денег кабинета — отдельный вопрос владельцу.
  const formatted = formatMoney(
    // WEB-1626 (F-4). Раньше здесь стояло жёсткое «/ 100», и функция врала:
    // код валюты она принимала, но использовала его ТОЛЬКО для значка. У иены,
    // воны, донга и ещё полутора десятков валют наименьшая единица — САМА
    // валюта, поэтому ¥1000 печатались как «¥10» — в сто раз меньше. Хуже
    // всего это било в тексте подтверждения ВОЗВРАТА (settings/
    // ServerChargesSection.tsx): человек принимал денежное решение по
    // заниженному числу, а `Intl` для иены и так печатает без копеек, так что
    // ошибка выглядела правдоподобно и ничем не сигналила.
    //
    // Делитель теперь один на весь фронт — общий справочник (зеркало
    // бэкендового, держится сторожем паритета), а не третья копия правила
    // печати денег. Для доллара, евро и всех вызовов БЕЗ второго аргумента
    // (внутренний баланс платформы) результат не изменился ни на цент:
    // у них наименьшая единица действительно сотая доля.
    minorUnitsToDisplayAmount(Math.abs(amountCents), currency),
    currency,
    undefined,
    'en',
  );

  return amountCents < 0 ? `-${formatted}` : formatted;
}
